import { lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ROLES } from '../constants/user-roles';
import NotFound from './auth/NotFound';
import { RequireAuth } from './auth/RequireAuth';
import { useConfig } from './bootstrap/ConfigProvider';

const Dashboard = lazy(() => import('./dashboard/Dashboard'));
const Views = lazy(() => import('./search-assets/Views'));
const Maintenance = lazy(() => import('./maintenance/Maintenance'));
const ManageUsers = lazy(() => import('./user-management/ManageUsers'));
const ScanResultsPage = lazy(() => import('./scans/ScanResultsPage'));
const QuickScanResults = lazy(() => import('./scans/QuickScanResults'));
const Reports = lazy(() => import('./reports/Reports'));
const Imports = lazy(() => import('./asset-import/Imports'));
const Help = lazy(() => import('./help/Help'));

const AssetRedirect = lazy(() =>
    import('./RedirectComponents').then(m => ({ default: m.AssetRedirect }))
);

const TagRedirect = lazy(() =>
    import('./RedirectComponents').then(m => ({ default: m.TagRedirect }))
);

export default function ContentRoutes() {
    const { helpMenu } = useConfig();

    return (
        <Routes>
            <Route path='/dashboard' element={<Navigate to='/folders' replace />} />

            <Route path='/folders/*' element={<Dashboard />} />

            <Route
                path='/maintenance/*'
                element={
                    <RequireAuth roles={[ROLES.ADMIN, ROLES.SYSTEM_ADMIN]}>
                        <Maintenance />
                    </RequireAuth>
                }
            />

            <Route path={`/asset/:id`} element={<AssetRedirect />} />

            <Route path='/tag/:tagNumber' element={<TagRedirect />} />

            <Route path='/assets/imports/*' element={<Imports />} />

            <Route path='/assets/*' element={<Views />} />

            <Route
                path='/users'
                element={
                    <RequireAuth roles={[ROLES.ADMIN, ROLES.SUPER_USER, ROLES.SYSTEM_ADMIN]}>
                        <ManageUsers />
                    </RequireAuth>
                }
            />

            <Route path='/scanresults/:id' element={<ScanResultsPage />} />

            <Route path='/scanresults' element={<ScanResultsPage />} />

            <Route path={`/quickscanresults/:id`} element={<QuickScanResults />} />

            <Route path='/reports/*' element={<Reports />} />

            {helpMenu?.enabled ? <Route path='/help' element={<Help />} /> : null}

            <Route path='/notfound' element={<NotFound />} />

            <Route path='/' element={<Navigate to='/dashboard' replace />} />

            <Route path='*' element={<NotFound />} />
        </Routes>
    );
}
